import { Platform } from 'react-native'

import { useIntl } from 'react-intl'

import ToggleGroupField from 'app/components/fields/ToggleGroupField'
import { receiveOptions } from 'app/utils/constants/options.constants'
import { transformIntlOptions } from 'app/utils/helpers/transforms.helper'

const ReviewsGroupField: RFC = ({}) => {
  const intl = useIntl()

  return (
    <ToggleGroupField
      name="receive"
      label={intl.formatMessage({
        defaultMessage: 'Reviews'
      })}
      items={transformIntlOptions(receiveOptions, intl.formatMessage)}
      itemSx={{
        mt: 1,
        ...Platform.select({
          web: {
            maxWidth: '100%',
            maxHeight: 36,

            '&:not(:last-child)': {
              marginRight: { md: 0, xs: 1.5 }
            }
          }
        })
      }}
      sx={{ flexDirection: { md: 'column', xs: 'row' } }}
    />
  )
}

export default ReviewsGroupField
